import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { MatMenuModule } from "@angular/material/menu";
import { RouterModule } from "@angular/router";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  standalone: true,
  selector: "cell-link",
  templateUrl: "cell-link.component.html",
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    RouterModule,
    CommonModule,
  ],
})
export class CellLinkComponent implements ICellRendererAngularComp {
  userId!: string;
  params!: ICellRendererParams;
  queryParams?: { [key: string]: string };
  showToolTip: boolean = true;
  inlineStyles = {};
  disableNavigation = false;
  customClass: string = "";
  data!: any;
  constructor() {}
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.queryParams =
      this.params.colDef?.cellRendererParams?.queryParams || null;
    if (this.params.colDef?.cellRendererParams?.showToolTip === false) {
      this.showToolTip = false;
    }
    if (this.params.colDef?.cellRendererParams?.inlineStyles) {
      this.inlineStyles = this.params.colDef?.cellRendererParams?.inlineStyles;
    }
    this.customClass =
      this.params.colDef?.cellRendererParams?.customClass || "";
    this.disableNavigation =
      this.params.colDef?.cellRendererParams?.disableNavigation || false;
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    if (this.params.colDef?.cellRendererParams?.showToolTip === false) {
      this.showToolTip = false;
    }
    this.disableNavigation =
      this.params.colDef?.cellRendererParams?.disableNavigation || false;
    return true;
  }
  onClick(): void {
    this.params.colDef?.cellRendererParams?.clicked(
      this.params.data,
      this.params.rowIndex
    );
  }
}
